import { render, staticRenderFns } from "./MyPriorities.vue?vue&type=template&id=53219ec6&scoped=true&"
import script from "./MyPriorities.vue?vue&type=script&lang=js&"
export * from "./MyPriorities.vue?vue&type=script&lang=js&"
import style0 from "./MyPriorities.vue?vue&type=style&index=0&id=53219ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53219ec6",
  null
  
)

export default component.exports